"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSchema = exports.VintageCurveFormulaDenominatorTypeIterable = void 0;
const _imports_1 = require("./_imports");
const LoanTapeField = __importStar(require("./LoanTapeField"));
exports.VintageCurveFormulaDenominatorTypeIterable = [
    'normalizedInitialBalance',
    'exposure',
];
// Zod schemas for LoanProductMechanics.Config
// Note: These reference schemas that are defined later in the file, so we use lazy loading
const AssignedLoanTapeCsvConfigSchema = _imports_1.z.object({
    type: _imports_1.z.enum(['include', 'exclude']),
    fields: _imports_1.z.array(_imports_1.z.string()),
});
const AssignedLoanTapeCsvConfigsSchema = _imports_1.z.object({
    extendedResponseTape: AssignedLoanTapeCsvConfigSchema.optional(),
    rawAssigned: AssignedLoanTapeCsvConfigSchema.optional(),
    generatedAssigned: AssignedLoanTapeCsvConfigSchema.optional(),
});
// ConfigSchema for LoanProductMechanics - uses lazy references for schemas defined later
exports.ConfigSchema = _imports_1.z.object({
    externalReceivableIdField: _imports_1.z.string(),
    rawExternalReceivableIdField: _imports_1.z.string().optional(),
    baseFieldConfigs: _imports_1.DataTapeField.BaseConfigSchema.array(),
    intermediateCalcConfigs: _imports_1.z
        .lazy(() => LoanTapeField.IntermediateCalcs.IntermediateCalcContainerSchema)
        .array(),
    signaledExternalAssignment: _imports_1.z
        .lazy(() => LoanTapeField.SignaledExternalAssignmentContainerSchema)
        .optional(),
    vintageCurveFormulaDenominator: _imports_1.z.enum(exports.VintageCurveFormulaDenominatorTypeIterable),
    assignedLoanTapeCsvConfigs: AssignedLoanTapeCsvConfigsSchema,
});
//# sourceMappingURL=LoanProductMechanics.js.map